/** Wordmark OLLYlife: serif + dot brand (trattamento della demo olly-final_v9),
 *  identico al `Wordmark` del sito pubblico (ollylife-web/SiteHeader).
 *  La taglia vive nel default della prop (non nelle classi base) così un
 *  `text-3xl` passato dal caller non collide con `text-xl` nel CSS generato. */
export function Wordmark({ className = 'text-xl' }: { className?: string }) {
  return (
    <span className={`flex items-end gap-0.5 font-serif leading-none tracking-tight text-tx ${className}`}>
      OLLYlife
      {/* dot in em: a text-xl coincide col sito (0.3em = 6px) e scala con la taglia */}
      <span className="mb-[0.2em] h-[0.3em] w-[0.3em] rounded-full bg-brand" />
    </span>
  )
}
